import { BlockDataDto } from 'theSource/queries';

export interface PageDetails {
  content_blocks?: ContentBlock[];
  page_text?: string;
}

export interface ContentBlock {
  label: string;
  url: string;
  iconClass: string;
  slotNum: number;
}

export const mapKeyActionDetails = (data: BlockDataDto[]): ContentBlock[] =>
  data?.map((contentBlock: BlockDataDto) => ({
    label: contentBlock.label,
    url: contentBlock.url,
    iconClass: contentBlock.container_css_class,
    slotNum: contentBlock.slot_num,
  }));
